// extracted by mini-css-extract-plugin
export default {"body":"LandingHow3_body__L8eJb"};